import { ReactNode } from "react";
import { create } from "zustand";

interface State {
    page: {
        children: ReactNode;
    } | null;
    setPage: (page: State["page"]) => void;
}

export const useModal = create<State>((set) => ({
    page: null,
    setPage: (page) => set({ page }),
}));
